import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash'
import { useSnackbar } from 'notistack'
import { Button, CircularProgress, Container, Grid, Typography } from '@material-ui/core'

import StepCard from '../../components/cards/StepCard/StepCard'
import EtiquetaProducto from '../../assets/svg/etiquetaProducto.svg'
import ClientHeader from '../../sections/headers/ClientHeader/ClientHeader'
import chooseProductsStyles from './css/chooseProductsStyles'
import usePrevious from '../../components/hooks/usePrevious'
import { fetchData } from '../../api/api'
import CustomTable from '../../components/table/CustomTable'

const headCellsSku = [{ id: 'id', numeric: false, order: false, label: 'Código de producto' }]

const createSkuRows = ({ id = '-' }) => {
  return { id }
}

const testRows = [
  {
    id: '20485641890',
  },
  {
    id: '20485641891',
  },
  {
    id: '20485641892',
  },
  {
    id: '20485641893',
  },
]

const ChooseProducts = ({ location }) => {
  const classes = chooseProductsStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const searchData = get(location, 'state')
  const view = 'chooseProduct'

  const [isLoading, setIsLoading] = useState(false)

  const [tableRows, setTableRows] = useState([])
  const [curretPage, setCurrentPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const [numberOfPages, setNumberOfPages] = useState(1)
  const [selectedRows, setSelectedRows] = useState([])
  const [isDataLoading, setIsDataLoading] = useState(false)

  const prevSearchData = usePrevious(searchData)

  useEffect(() => {
    const fetchFormData = async () => {
      setIsDataLoading(true)
      try {
        const tableDataApi = await fetchData({ ...searchData, rowsPerPage, curretPage })
        setNumberOfPages(get(tableDataApi, 'pages.total') || 1)
        setTableRows(
          (get(tableDataApi, 'data') || []).map(row =>
            createSkuRows({
              id: get(row, 'id'),
              date: get(row, 'price'),
              view,
            })
          )
        )

        return setIsDataLoading(false)
      } catch (error) {
        setIsDataLoading(false)
        return error
      }
    }
    // if (!isEqual(prevSearchData, searchData)) fetchFormData()
  }, [prevSearchData, searchData])

  const handleConfirmClick = () => {
    return history.push({
      pathname: 'ticket-cliente',
    })
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <ClientHeader
          title="Selecciona los productos "
          subTitle="Elige los productos que desees cambiar o devolver con tu ticket siguiendo estos pasos:"
          step="2"
          totalSteps="3"
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StepCard stepNumber={1}>
              <div>
                <Typography align="left" gutterBottom>
                  Encuentra la etiqueta del producto y anota los números debajo del código de
                  barras.
                </Typography>
                <Typography align="left">
                  Este es el{' '}
                  <Typography align="left" component="span" className={classes.boldFont}>
                    código del producto.
                  </Typography>
                </Typography>

                <img src={EtiquetaProducto} alt="Boleta Tienda" className={classes.img} />

                <Typography align="left">
                  ¿No encuentras la etiqueta? Descuida, también puedes encontrarlos en el{' '}
                  <Typography align="left" component="span" className={classes.boldFont}>
                    código de barras del mismo producto.
                  </Typography>
                </Typography>
              </div>
            </StepCard>
          </Grid>
          <Grid item xs={12}>
            <StepCard stepNumber={2}>
              <div className={classes.tableContainer}>
                <Typography>
                  Selecciona los códigos de productos que deseas cambiar o devolver
                </Typography>

                <CustomTable
                  className={classes.table}
                  rows={testRows}
                  headCells={headCellsSku}
                  actionTable
                  eraseButton
                  page={curretPage}
                  setPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  order={order}
                  setOrder={setOrder}
                  orderBy={orderBy}
                  setOrderBy={setOrderBy}
                  isDataLoading={isDataLoading}
                  numberOfPages={numberOfPages}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  checkTable
                  hidePagination
                />

                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  style={{ height: 56 }}
                  onClick={handleConfirmClick}
                >
                  {isLoading ? <CircularProgress /> : 'CONFIRMAR SELECCIÓN'}
                </Button>
              </div>
            </StepCard>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default ChooseProducts
